"use strict";
// TODO: Remove AFT ApiErrorCodes, mappings, and any other references when SMS depractes AFT-XXXX codes
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationType = exports.ApiErrorMappings = exports.ApiErrorCodes = void 0;
var ApiErrorCodes;
(function (ApiErrorCodes) {
    // GSF
    ApiErrorCodes["GSF-1000"] = "GSF-1000";
    ApiErrorCodes["GSF-1001"] = "GSF-1001";
    ApiErrorCodes["GSF-1002"] = "GSF-1002";
    ApiErrorCodes["GSF-1003"] = "GSF-1003";
    ApiErrorCodes["GSF-1004"] = "GSF-1004";
    ApiErrorCodes["GSF-1005"] = "GSF-1005";
    ApiErrorCodes["GSF-1006"] = "GSF-1006";
    ApiErrorCodes["GSF-1007"] = "GSF-1007";
    ApiErrorCodes["GSF-1008"] = "GSF-1008";
    ApiErrorCodes["GSF-1009"] = "GSF-1009";
    ApiErrorCodes["GSF-1010"] = "GSF-1010";
    ApiErrorCodes["GSF-2000"] = "GSF-2000";
    ApiErrorCodes["GSF-2001"] = "GSF-2001";
    ApiErrorCodes["GSF-2002"] = "GSF-2002";
    ApiErrorCodes["GSF-2003"] = "GSF-2003";
    ApiErrorCodes["GSF-2004"] = "GSF-2004";
    ApiErrorCodes["GSF-2005"] = "GSF-2005";
    ApiErrorCodes["GSF-2006"] = "GSF-2006";
    ApiErrorCodes["GSF-2007"] = "GSF-2007";
    ApiErrorCodes["GSF-2008"] = "GSF-2008";
    ApiErrorCodes["GSF-2009"] = "GSF-2009";
    ApiErrorCodes["GSF-9999"] = "GSF-9999";
    ApiErrorCodes["GSF-3000"] = "GSF-3000";
    // AFT ineligiblility reason,
    ApiErrorCodes["AFT-1000"] = "AFT-1000";
    ApiErrorCodes["AFT-1001"] = "AFT-1001";
    ApiErrorCodes["AFT-1002"] = "AFT-1002";
    ApiErrorCodes["AFT-1003"] = "AFT-1003";
    ApiErrorCodes["AFT-1004"] = "AFT-1004";
    ApiErrorCodes["AFT-1005"] = "AFT-1005";
    ApiErrorCodes["AFT-1006"] = "AFT-1006";
    ApiErrorCodes["AFT-1007"] = "AFT-1007";
    ApiErrorCodes["AFT-1008"] = "AFT-1008";
    ApiErrorCodes["AFT-1009"] = "AFT-1009";
    ApiErrorCodes["AFT-1010"] = "AFT-1010";
    ApiErrorCodes["AFT-1011"] = "AFT-1011";
    ApiErrorCodes["AFT-1012"] = "AFT-1012";
    ApiErrorCodes["AFT-1013"] = "AFT-1013";
    ApiErrorCodes["AFT-1014"] = "AFT-1014";
    ApiErrorCodes["AFT-1015"] = "AFT-1015";
    ApiErrorCodes["AFT-1017"] = "AFT-1017";
    ApiErrorCodes["AFT-2000"] = "AFT-2000";
    ApiErrorCodes["AFT-2001"] = "AFT-2001";
    ApiErrorCodes["AFT-2002"] = "AFT-2002";
    ApiErrorCodes["AFT-9999"] = "AFT-9999";
    ApiErrorCodes["AFT-3000"] = "AFT-3000";
    // SMS ineligiblility reason
    ApiErrorCodes["SMS-1000"] = "SMS-1000";
    ApiErrorCodes["SMS-1001"] = "SMS-1001";
    ApiErrorCodes["SMS-1002"] = "SMS-1002";
    ApiErrorCodes["SMS-1003"] = "SMS-1003";
    ApiErrorCodes["SMS-1004"] = "SMS-1004";
    ApiErrorCodes["SMS-1005"] = "SMS-1005";
    ApiErrorCodes["SMS-1006"] = "SMS-1006";
    ApiErrorCodes["SMS-1007"] = "SMS-1007";
    ApiErrorCodes["SMS-1008"] = "SMS-1008";
    ApiErrorCodes["SMS-1009"] = "SMS-1009";
    ApiErrorCodes["SMS-1010"] = "SMS-1010";
    ApiErrorCodes["SMS-1011"] = "SMS-1011";
    ApiErrorCodes["SMS-1012"] = "SMS-1012";
    ApiErrorCodes["SMS-1013"] = "SMS-1013";
    ApiErrorCodes["SMS-1014"] = "SMS-1014";
    ApiErrorCodes["SMS-1015"] = "SMS-1015";
    ApiErrorCodes["SMS-1016"] = "SMS-1016";
    ApiErrorCodes["SMS-1017"] = "SMS-1017";
    ApiErrorCodes["SMS-1019"] = "SMS-1019";
    ApiErrorCodes["SMS-2000"] = "SMS-2000";
    ApiErrorCodes["SMS-2001"] = "SMS-2001";
    ApiErrorCodes["SMS-2002"] = "SMS-2002";
    ApiErrorCodes["SMS-9999"] = "SMS-9999";
    ApiErrorCodes["SMS-3000"] = "SMS-3000";
    // Shift swap error keys
    ApiErrorCodes["SWAP_NOT_COMPLETED"] = "SWAP_NOT_COMPLETED";
    ApiErrorCodes["SWAP_NOT_CANCELLED"] = "SWAP_NOT_CANCELLED";
    // Punch correction error keys
    ApiErrorCodes["CORRECTION_NOT_CONFIRMED"] = "CORRECTION_NOT_CONFIRMED";
})(ApiErrorCodes = exports.ApiErrorCodes || (exports.ApiErrorCodes = {}));
// Note: Commented mappings means we don't have existing translations for those codes
exports.ApiErrorMappings = (_a = {},
    _a[ApiErrorCodes['GSF-1000']] = 'HRS_PER_DAY',
    _a[ApiErrorCodes['GSF-1001']] = 'HRS_PER_DAY_AT_SITE',
    _a[ApiErrorCodes['GSF-1002']] = 'HRS_PER_WEEK',
    _a[ApiErrorCodes['GSF-1003']] = 'HRS_PER_WEEK_AT_SITE',
    _a[ApiErrorCodes['GSF-1004']] = 'DAYS_PER_WEEK',
    _a[ApiErrorCodes['GSF-1005']] = 'DAYS_IN_A_ROW',
    _a[ApiErrorCodes['GSF-1006']] = 'DIFF_BETWEEN_END_SHIFT_AND_START_NEW_SHIFT_IN_MINUTES',
    _a[ApiErrorCodes['GSF-1007']] = 'DIFF_BETWEEN_END_NEW_SHIFT_AND_START_SHIFT_IN_MINUTES',
    _a[ApiErrorCodes['GSF-1008']] = 'UNHANDLED',
    _a[ApiErrorCodes['GSF-1009']] = 'CLOPENING_REQUIRED_BREAK_IN_HOURS',
    _a[ApiErrorCodes['GSF-1010']] = 'HOURS_WORKED_IN_24_HOUR_SHIFT_WINDOW',
    _a[ApiErrorCodes['GSF-2000']] = 'OVERLAPPING_SHIFT',
    _a[ApiErrorCodes['GSF-2001']] = 'OPPORTUNITY_CAPACITY_MET',
    _a[ApiErrorCodes['GSF-2002']] = 'DUPLICATE_CROSS_TRAINING',
    _a[ApiErrorCodes['GSF-2003']] = 'MISSING_SKILL',
    _a[ApiErrorCodes['GSF-2004']] = 'ALREADY_CLAIMED',
    _a[ApiErrorCodes['GSF-2005']] = 'SHIFT_IS_IN_THE_PAST',
    _a[ApiErrorCodes['GSF-2006']] = 'ALREADY_DROPPED',
    _a[ApiErrorCodes['GSF-2007']] = 'INSUFFICIENT_INCENTIVES',
    _a[ApiErrorCodes['GSF-2008']] = 'INELIGIBLE_DEFAULT',
    _a[ApiErrorCodes['GSF-2009']] = 'SHIFT_WINDOW_MISMATCH',
    _a[ApiErrorCodes['GSF-9999']] = 'UNKNOWN',
    _a[ApiErrorCodes['GSF-3000']] = 'INVALID_DROP_OPPORTUNITY',
    // AFT ineligiblility reasons
    _a[ApiErrorCodes['AFT-1000']] = 'OVERLAPPING_SHIFT',
    _a[ApiErrorCodes['AFT-1001']] = 'SHIFT_TYPE_MISMATCH',
    _a[ApiErrorCodes['AFT-1002']] = 'SKILL_MISMATCH',
    // [ApiErrorCodes['AFT-1003']]: 'STAFFING_SHORTAGE',
    _a[ApiErrorCodes['AFT-1004']] = 'MINIMUM_GAP_BETWEEN_SHIFTS_VIOLATION',
    _a[ApiErrorCodes['AFT-1005']] = 'MINIMUM_BREAK_DURATION_VIOLATION',
    // [ApiErrorCodes['AFT-1006']]: 'MINIMUM_WORKING_DURATION_VIOLATION',
    _a[ApiErrorCodes['AFT-1007']] = 'DAYS_IN_A_ROW',
    _a[ApiErrorCodes['AFT-1008']] = 'HRS_PER_WEEK',
    _a[ApiErrorCodes['AFT-1009']] = 'HRS_PER_DAY',
    // [ApiErrorCodes['AFT-1010']]: 'SHIFT_WINDOW_MISMATCH',
    _a[ApiErrorCodes['AFT-1011']] = 'ASSOCIATE_ABSENT',
    _a[ApiErrorCodes['AFT-1012']] = 'MAX_SHIFTS_PER_DAY_VIOLATION',
    _a[ApiErrorCodes['AFT-1013']] = 'ASSOCIATE_TYPE_MISMATCH_READY_ONLY',
    _a[ApiErrorCodes['AFT-1014']] = 'ASSOCIATE_TYPE_MISMATCH_NON_READY_ONLY',
    _a[ApiErrorCodes['AFT-1015']] = 'SCHEDULE_INVALID_STATE',
    _a[ApiErrorCodes['AFT-1017']] = 'MAX_HOURS_PER_ROLLING_4_MONTH_VIOLATION',
    _a[ApiErrorCodes['AFT-2000']] = 'ASSOCIATE_ACCEPTED',
    _a[ApiErrorCodes['AFT-2001']] = 'SHIFT_OPPORTUNITY_CAPACITY_MET',
    _a[ApiErrorCodes['AFT-2002']] = 'SHIFT_OPPORTUNITY_EXPIRED',
    _a[ApiErrorCodes['AFT-9999']] = 'UNKNOWN',
    _a[ApiErrorCodes['AFT-3000']] = 'INVALID_DROP_OPPORTUNITY',
    // SMS ineligiblility reasons
    _a[ApiErrorCodes['SMS-1000']] = 'OVERLAPPING_SHIFT',
    _a[ApiErrorCodes['SMS-1001']] = 'SHIFT_TYPE_MISMATCH',
    _a[ApiErrorCodes['SMS-1002']] = 'SKILL_MISMATCH',
    // [ApiErrorCodes['SMS-1003']]: 'STAFFING_SHORTAGE',
    _a[ApiErrorCodes['SMS-1004']] = 'MINIMUM_GAP_BETWEEN_SHIFTS_VIOLATION',
    _a[ApiErrorCodes['SMS-1005']] = 'MINIMUM_BREAK_DURATION_VIOLATION',
    // [ApiErrorCodes['SMS-1006']]: 'MINIMUM_WORKING_DURATION_VIOLATION',
    _a[ApiErrorCodes['SMS-1007']] = 'DAYS_IN_A_ROW',
    _a[ApiErrorCodes['SMS-1008']] = 'HRS_PER_WEEK',
    _a[ApiErrorCodes['SMS-1009']] = 'HRS_PER_DAY',
    // [ApiErrorCodes['SMS-1010']]: 'SHIFT_WINDOW_MISMATCH',
    _a[ApiErrorCodes['SMS-1011']] = 'ASSOCIATE_ABSENT',
    _a[ApiErrorCodes['SMS-1012']] = 'MAX_SHIFTS_PER_DAY_VIOLATION',
    _a[ApiErrorCodes['SMS-1013']] = 'ASSOCIATE_TYPE_MISMATCH_READY_ONLY',
    _a[ApiErrorCodes['SMS-1014']] = 'ASSOCIATE_TYPE_MISMATCH_NON_READY_ONLY',
    _a[ApiErrorCodes['SMS-1015']] = 'SCHEDULE_INVALID_STATE',
    _a[ApiErrorCodes['SMS-1016']] = 'MAX_HOURS_PRE_ROLLING_DAY_VIOLATION',
    _a[ApiErrorCodes['SMS-1017']] = 'MAX_HOURS_PER_ROLLING_4_MONTH_VIOLATION',
    _a[ApiErrorCodes['SMS-1019']] = 'INVALID_DROP_OPPORTUNITY_PTO_OVERLAP',
    _a[ApiErrorCodes['SMS-2000']] = 'ASSOCIATE_ACCEPTED',
    _a[ApiErrorCodes['SMS-2001']] = 'SHIFT_OPPORTUNITY_CAPACITY_MET',
    _a[ApiErrorCodes['SMS-2002']] = 'SHIFT_OPPORTUNITY_EXPIRED',
    _a[ApiErrorCodes['SMS-9999']] = 'UNKNOWN',
    _a[ApiErrorCodes['SMS-3000']] = 'INVALID_DROP_OPPORTUNITY',
    // Shift swap error keys
    _a[ApiErrorCodes['SWAP_NOT_COMPLETED']] = 'SWAP_NOT_COMPLETED',
    _a[ApiErrorCodes['SWAP_NOT_CANCELLED']] = 'SWAP_NOT_CANCELLED',
    // Punch correction error keys
    _a[ApiErrorCodes['CORRECTION_NOT_CONFIRMED']] = 'CORRECTION_NOT_CONFIRMED',
    _a);
var OperationType;
(function (OperationType) {
    OperationType["ACCEPT_VTO"] = "ACCEPT_VTO";
})(OperationType = exports.OperationType || (exports.OperationType = {}));
